import React, { Fragment } from 'react'
import { getMessage } from 'lib/translator'
import API from 'lib/api'
import { Popup, Dialog } from 'components/Popup'
import { BaseForm, VALIDATION_TYPES, Select, Checkbox } from 'components/Form'
import { SingleDatePicker } from 'components/Form/Inputs'
import Tabs from 'components/Tabs'
import InfoCard from 'components/InfoCard'
import Loader from 'components/Loader'
import CustomerDetailsCard from 'components/CustomerDetailsCard'
import Table, { Header, Row, Cell } from 'components/Table'
import { LINKPASS_ADMIN_URL } from 'config/app'
import InitialBalanceImage from 'pages/operations/Customers/Details/total-orders.svg'
import BalanceImage from 'pages/operations/Customers/Details/purchase-worth.svg'
import CreatedImage from 'pages/operations/Customers/Details/joined-on.svg'
import { formatIsoDate } from '../../lib/datetime'
import calendarIcon from './calender-icon.svg'
import './style.css'

const VOUCHER_STATUS = [
  {
    text: 'Disable',
    value: 'DISABLED',
  },
]

class SearchResults extends BaseForm {
  constructor(props) {
    super(props)

    this.state = {
      isModalOpen: false,
      modalData: {},
      values: {},
      customer: null,
      customerLoading: false,
    }
  }

  componentDidMount() {
    this.fetchCustomer()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.response?.uid !== this.props.response?.uid) {
      this.fetchCustomer()
    }
  }

  async fetchCustomer() {
    const uid = this.props.response?.uid
    if (!uid) {
      this.setState({ customer: null })
      return
    }
    this.setState({ customerLoading: true })
    try {
      const api = new API({
        url: `${LINKPASS_ADMIN_URL}/linkpass-admin-service/user/uid/${uid}`,
      })
      const response = await api.get()
      this.setState({
        customer: {
          id: response.association?.fairprice,
          name: response.name,
          email: response.email,
          phone: response.phone_number,
          uid: response.uid,
        },
      })
    } catch (error) {
      if (error.code === 401) {
        throw error
      }
      this.setState({ customer: null })
    } finally {
      this.setState({ customerLoading: false })
    }
  }

  async updateFormHandler() {
    const values = Object.assign({}, this.state.values)
    values.response = ''
    values.error = ''
    this.setState({
      values: values,
    })
    const { newExpiryDate, newStatus } = this.state.values
    const data = {
      expiresAt: newExpiryDate,
      status: newStatus,
    }

    this.beforeSubmit(this.state.values)
    this.setState({
      pressedSubmitWithCurrentData: true,
    })
    try {
      const api = new API({ url: `/vouchers/${this.props.response.code}` })
      const response = await api.patch(data)
      values.response = response
      values.updatePopup = false
      values.success = true
      this.setState({
        values: values,
      })
    } catch (error) {
      values.error = error.message || 'No results found.'
      this.setState({
        values: values,
      })
    }
  }

  handleCloseSuccessMessage() {
    const values = Object.assign({}, this.state.values)
    values.success = false
    this.setState({
      values: values,
    })
  }

  async _submitHandler(e) {
    e && e.preventDefault()
    const values = Object.assign({}, this.state.values)
    values.updatePopup = true
    this.setState({
      values: values,
    })
  }

  renderSuccess() {
    return this.state.values.success ? (
      <div className="col-4 search-success" id="succcess-dialog">
        {getMessage('banners.success.dialog.message')}
        <strong
          data-testid="ok-strng-btn"
          onClick={() => this.handleCloseSuccessMessage()}
          className="strong-btn"
        >
          {getMessage('rewardPage.dialogs.disable.okText')}
        </strong>
      </div>
    ) : (
      <></>
    )
  }

  renderCustomer() {
    const { customer, customerLoading } = this.state
    const { uid } = this.props.response
    if (!uid) {
      return (
        <div className="evoucher-customer-empty" data-testid="customer-empty">
          Voucher is not assigned
        </div>
      )
    }
    if (customerLoading) {
      return <Loader size="sm" />
    }
    // falls back to the voucher uid when the profile lookup fails
    return (
      <CustomerDetailsCard
        email={customer?.email}
        phone={customer?.phone}
        uid={customer?.uid || uid}
        name={customer?.name}
        id={customer?.id}
        hideActions
      />
    )
  }

  renderBasicInfo() {
    const { SubmitButton, CancelButton } = this.buttons
    const { response } = this.props

    return (
      <div className="tab-details">
        <div className="row status">
          <h3>
            Status:
            <span className={`${this.props.status} ml`}>
              {this.props.status}
            </span>
          </h3>
        </div>
        <div className="tab-row">
          <InfoCard
            className="initial-balance"
            src={InitialBalanceImage}
            title="Initial balance"
            description={`$${response.initialBalance.toFixed(2)}`}
          />
          <InfoCard
            className="current-balance"
            src={BalanceImage}
            title="Current balance"
            description={`$${response.balance.toFixed(2)}`}
          />
        </div>
        <div className="tab-row">
          <InfoCard
            className="created-on"
            src={CreatedImage}
            title="Created On"
            description={formatIsoDate(response.createdAt)}
          />
          <InfoCard
            className="expires-on"
            src={calendarIcon}
            title="Expires On"
            description={formatIsoDate(response.expiresAt)}
          />
        </div>
        <div className="row mt">
          <div className="col-4">
            <label>Voucher Code:</label>
          </div>
          <div className="col-4">
            <label className="blue ">{response.code}</label>
          </div>
        </div>
        <div className="row mt">
          <div className="col-4">
            <label>Batch ID:</label>
          </div>
          <div className="col-4">
            <label className="blue ">{response.batchId}</label>
          </div>
        </div>
        <div className="row mt">
          <div className="col-4">
            <label>Entity Name:</label>
          </div>
          <div className="col-4">
            <label className="blue ">{response.entityName}</label>
          </div>
        </div>
        {!response.cannotExtendPast && (
          <div className="row mt">
            <div className="col-4">
              <label>
                {getMessage('eVoucher.update.newexpiry')}{' '}
                {<img src={calendarIcon} alt="calendar" />}:
              </label>
            </div>
            <div className="col-4">
              <SingleDatePicker
                openDirection="up"
                enableToday={false}
                id="expiryPicker"
                name="expiryPicker"
                {...this.generateStateMappers({
                  stateKeys: ['newExpiryDate'],
                  validationType: VALIDATION_TYPES.ONSUBMIT,
                })}
              />
            </div>
          </div>
        )}
        <div className="row mt">
          <div className="col-4">
            <label>{getMessage('eVoucher.update.status')} </label>
          </div>
          <div className="col-4">
            <Select
              name="status-selector"
              options={[
                response.status !== 'ENABLED' && {
                  text: 'Enable',
                  value: 'ENABLED',
                },
                ...VOUCHER_STATUS,
              ]}
              {...this.generateStateMappers({
                stateKeys: ['newStatus'],
                validationType: VALIDATION_TYPES.ONSUBMIT,
                loseEmphasisOnFill: true,
              })}
            />
          </div>
        </div>
        <div className="row mt">
          <div className="col-4">
            <label>{getMessage('eVoucher.create.allow')} </label>
          </div>
          <div className="col-4">
            <Checkbox
              name="cannotExtendPast"
              {...this.generateStateMappers({
                stateKeys: ['cannotExtendPast'],
                loseEmphasisOnFill: true,
              })}
              value={!response.cannotExtendPast}
              disabled
            />
          </div>
        </div>
        <div className="row">
          <div className="form-actions">
            <SubmitButton testid="confirm-submit">Submit</SubmitButton>
            <CancelButton testid="cancel-submit">Cancel</CancelButton>
          </div>
        </div>
      </div>
    )
  }

  renderPurchaseHistory() {
    const { transactions } = this.props.response

    return (
      <Fragment>
        <h3>Purchase History</h3>
        <div className="purchase-history">
          {transactions.length === 0 ? (
            <label className="empty-transactions">No transactions found</label>
          ) : (
            <Table>
              <Header items={['Date', 'Store', 'Type', 'Order ID', 'Amount']} />
              {transactions.map((res, i) => {
                const isRefund = res.type === 'REFUND'
                return (
                  <Row
                    testId={`refund-btn-${i}`}
                    key={i}
                    className={isRefund ? 'refund-pointer' : ''}
                    onClick={() => {
                      this.setState({ modalData: res })
                      this.setState({ isModalOpen: true })
                    }}
                  >
                    <Cell>{formatIsoDate(res.createdAt)}</Cell>
                    <Cell>{res.storeName}</Cell>
                    <Cell className="transaction-type">
                      {isRefund ? 'Refund' : 'Redemption'}
                    </Cell>
                    <Cell>{res.orderId || '-'}</Cell>
                    <Cell align="right">
                      <span className="amount">{`${
                        isRefund ? '+' : '-'
                      }$${res.amount.toFixed(2)}`}</span>
                    </Cell>
                  </Row>
                )
              })}
            </Table>
          )}
        </div>
      </Fragment>
    )
  }

  renderResponse() {
    return (
      <div className="evoucher-details">
        <div className="tab-with-customer-card">
          <div className="tab-container">
            <Tabs items={['Basic Info']} default={0} />
            {this.renderBasicInfo()}
          </div>
          <div>{this.renderCustomer()}</div>
        </div>
        {this.renderPurchaseHistory()}
      </div>
    )
  }

  renderDialog = () => {
    return (
      <Dialog
        show={this.state.values.updatePopup}
        title={getMessage('deleteDialog.title')}
        information={getMessage('eVoucher.update.resultDetails')}
        onOk={() => this.updateFormHandler()}
        close={() => {
          const values = Object.assign({}, this.state.values)
          values.updatePopup = false
          this.setState({
            values: values,
          })
        }}
        closeText={getMessage('dialog.cancelText')}
        okText={getMessage('dialog.okText')}
      />
    )
  }

  render() {
    const { Form } = this.components

    return (
      <Form>
        {this.renderSuccess()}
        {this.renderDialog()}
        <div className="search-container contain mt">
          <div
            className={`search-result-wrapper ${
              this.props.response ? 'has-details' : ''
            }`}
            data-testid="search-results"
          >
            <Popup
              show={this.state.isModalOpen}
              heading={getMessage('eVoucher.refund.title')}
              close={() => this.setState({ isModalOpen: false })}
            >
              <div className="container">
                <div className="row">
                  <div className="col-6">
                    <h1>ID:</h1>
                  </div>
                  <div className="col-6">
                    <h1>{this.state.modalData.id}</h1>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <h1>Merchant ID:</h1>
                  </div>
                  <div className="col-6">
                    <h1>{this.state.modalData.merchantId}</h1>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <h1>Store Code:</h1>
                  </div>
                  <div className="col-6">
                    <h1>{this.state.modalData.storeCode}</h1>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <h1>Order ID:</h1>
                  </div>
                  <div className="col-6">
                    <h1>{this.state.modalData.orderId}</h1>
                  </div>
                </div>
              </div>
            </Popup>
            {this.props.error && (
              <p className="text-center">{this.props.error}</p>
            )}
            {this.props.response && this.renderResponse()}
          </div>
        </div>
      </Form>
    )
  }
}

export default SearchResults
